import { Check } from 'lucide-react';

export function ProcessBar({ steps, step }) {
  return (
    <div className="flex items-center gap-0 mb-3" data-testid="process-bar">
      {steps.map((s, i) => {
        const idx = i + 1;
        const done = idx < step;
        const active = idx === step;
        return (
          <div key={s} className="flex items-center" style={{ flex: i < steps.length - 1 ? 1 : 'none' }}>
            <div className="flex items-center gap-1.5">
              <div className="w-5 h-5 rounded-full flex items-center justify-center text-[10px] font-bold flex-shrink-0"
                style={{
                  background: done ? '#2563EB' : active ? '#2563EB' : '#F3F4F6',
                  color: done || active ? '#FFF' : '#9CA3AF',
                }}>
                {done ? <Check className="w-3 h-3" /> : idx}
              </div>
              <span className="text-[10px] font-medium whitespace-nowrap"
                style={{ color: done || active ? '#2563EB' : '#9CA3AF' }}>
                {s}
              </span>
            </div>
            {i < steps.length - 1 && (
              <div className="flex-1 h-px mx-2" style={{ background: done ? '#2563EB' : '#E5E7EB' }} />
            )}
          </div>
        );
      })}
    </div>
  );
}

export function GenerationSteps({ step }) {
  const STEPS = [
    'Caricamento contesto brand',
    'Analisi post precedenti',
    'Composizione prompt',
    'Generazione testo',
  ];
  return (
    <div className="flex flex-col items-center justify-center py-8" data-testid="generation-steps">
      <div className="w-14 h-14 rounded-full flex items-center justify-center text-white text-lg font-bold mb-5"
        style={{ background: 'var(--color-agent-copywriter, #2563EB)' }}>
        CW
      </div>
      <div className="space-y-3 w-full max-w-[220px]">
        {STEPS.map((s, i) => {
          const idx = i + 1;
          const done = idx < step;
          const active = idx === step;
          return (
            <div key={s} className="flex items-center gap-2.5">
              {done ? (
                <div className="w-5 h-5 rounded-full flex items-center justify-center flex-shrink-0" style={{ background: '#059669' }}>
                  <Check className="w-3 h-3 text-white" />
                </div>
              ) : active ? (
                <div className="w-5 h-5 rounded-full border-2 border-blue-500 border-t-transparent animate-spin flex-shrink-0" />
              ) : (
                <div className="w-5 h-5 rounded-full flex-shrink-0" style={{ background: '#F3F4F6' }} />
              )}
              <span className="text-[11px]" style={{
                color: done ? '#059669' : active ? '#2563EB' : 'var(--color-muted)',
                fontWeight: active ? 600 : 400,
              }}>{s}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
